const allowGTMTracking = (): void => {
  if (window['dataLayer']) {
    window['dataLayer'].push([
      'consent', 'update', {
        'ad_storage': 'granted',
        'analytics_storage': 'granted'
      }
    ])
  }
}

export default allowGTMTracking